/**
 * @Event 方法
 * @description: 过滤器，将文件路径处理成正确的地址；
 * */
export function imgFormat(url) {
  if (typeof url === "string") {
    return process.env.NODE_ENV === "production" ? "/msx" + url : url;
  }
  if (typeof url === "object") {
    return process.env.NODE_ENV === "production" ? ["/msx" + url[0]] : url;
  }
}

export default { imgFormat };
